import * as React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main';
import { useTranslation } from 'react-i18next';

export const VideoDeletion = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Video Expiration')} />
      <PageTemplate main={<Main />} />
    </>
  );
};
